// Simple in-memory auth token store for web clients.
// Purpose: avoid persisting long-lived refresh tokens in localStorage.

let accessToken = null;
let accessTokenExpiry = null; // ms epoch

export function setAccessToken(token, expiresInSeconds = null) {
  accessToken = token || null;
  if (expiresInSeconds) {
    accessTokenExpiry = Date.now() + Number(expiresInSeconds) * 1000;
  } else {
    accessTokenExpiry = null;
  }
}

export function getAccessToken() {
  return accessToken;
}

export function getAccessTokenExpiry() {
  return accessTokenExpiry;
}

export function clearAuth() {
  accessToken = null;
  accessTokenExpiry = null;
}

// Helper: boolean whether access token is expired or missing
export function isAccessTokenExpired(thresholdMs = 0) {
  if (!accessToken) return true;
  if (!accessTokenExpiry) return false;
  return Date.now() + thresholdMs >= accessTokenExpiry;
}

export default {
  setAccessToken,
  getAccessToken,
  getAccessTokenExpiry,
  clearAuth,
  isAccessTokenExpired
};
